import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from '../../routes';

const Map = () => {
    const location = useLocation();
    const isCampusLife = location.pathname.toLowerCase() === '/campus%20Life'.toLowerCase();
    const isKshasCampus = location.pathname.toLowerCase() === '/campus%20Life/KSHAS%20Campus'.toLowerCase();
    const [isMainCampusHover, setIsMainCampusHover] = useState(isCampusLife);
    const [isKshasCampusHover, setIsKshasCampusHover] = useState(isKshasCampus);
    const navigate = useNavigate(null)

    useEffect(() => {
        setIsMainCampusHover(isCampusLife);
        setIsKshasCampusHover(isKshasCampus);
    }, [isCampusLife, isKshasCampus]);

    return (
        <div className="w-fit relative group">
            <img
                className={`absolute left-0  cursor-pointer ${isMainCampusHover ? "scale-100  -translate-x-0 translate-y-0 opacity-100 z-[2]" : "opacity-70 z-[3] translate-y-16 -translate-x-8 scale-[.6]"

                    }
                transition-all duration-500  object-cover`}
                src="/assets/loc1_pin.svg"
                alt="photo"
                onClick={()=>{
                    navigate(`/${routes.campusLife.main}`)
                }}
                onMouseEnter={() => {
                    setIsMainCampusHover(true);
                    setIsKshasCampusHover(false);
                }}
            //    onMouseLeave={() => {
            //         setIsKshasCampusHover(isKshasCampus);
            //         setIsMainCampusHover(isCampusLife);
            //     }}
            />
            <img
                className={`absolute left-0   cursor-pointer  ${isMainCampusHover ? "opacity-100 z-[1] " : "opacity-0 z-[-1]"} transition-all duration-500  object-cover`}
                src="/assets/loc1.svg"
                alt="photo"
            />

            <img
                className={`absolute   right-0  cursor-pointer ${isKshasCampusHover ? "scale-100 0  -translate-x-0 translate-y-0 opacity-100 z-[2]" : "z-[3] opacity-70 translate-y-36 translate-x-10 scale-[.6]"
                    } 
                      transition-all duration-500  object-cover`}
                src="/assets/loc2_pin.svg"
                alt="photo"
                onClick={()=>{
                    navigate(routes.campusLife.kshasCampus)
                }}
                onMouseEnter={() => {
                    setIsKshasCampusHover(true);
                    setIsMainCampusHover(false);
                }}
                // onMouseLeave={() => {
                //     setIsKshasCampusHover(isKshasCampus);
                //     setIsMainCampusHover(isCampusLife);
                // }}
            />
            <img
                className={`absolute right-0  cursor-pointer  ${isKshasCampusHover ? "opacity-100  z-[1]" : "opacity-0 z-[-1]"} 
               
                transition-all duration-500  object-cover`}
                src="/assets/loc2.svg"
                alt="photo"
            />

            <img className=" object-cover" src="/assets/campLocation1.svg" alt="photo" />
        </div>
    );
};

export default Map;
